'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Key = require('interface-datastore').Key;

var debug = require('debug');

var log = debug('repo:version');
var versionKey = new Key('version');

module.exports = function (store) {
  return {
    /**
     * Check if a version file exists.
     *
     * @returns {Promise<bool>}
     */
    exists: function exists() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", store.has(versionKey));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * Get the current version.
     *
     * @returns {Promise<Integer>}
     */
    get: function get() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var buf;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return store.get(versionKey);

              case 2:
                buf = _context2.sent;
                return _context2.abrupt("return", parseInt(buf.toString().trim(), 10));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * Set the version of the repo, writing it to the underlying store.
     *
     * @param {number} version
     * @returns {Promise<void>}
     */
    set: function set(version) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", store.put(versionKey, Buffer.from(String(version))));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Check the current version, and returns true if versions matches
     * @param {number} expected
     * @returns {boolean}
     */
    check: function check(expected) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var version, compatibleVersion;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.get();

              case 2:
                version = _context4.sent;
                log('comparing version: %s and %s', version, expected); // Version 6 and 7 are the same
                // TODO: Clean up the compatibility logic. Repo feature detection would be ideal, or a better version schema

                compatibleVersion = version === 6 && expected === 7 || expected === 6 && version === 7;
                return _context4.abrupt("return", version === expected || compatibleVersion);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  };
};